import { Component, AfterViewInit, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-select-coordinates-modal",
  standalone: true,
  imports: [MatDialogModule, MatIconModule],
  template: `
    <div class="mr-1 mb-1 content-right">
      <mat-icon class="cursor-pointer close-icon" matDialogClose
        >close</mat-icon
      >
    </div>
    <h2 mat-dialog-title>Seleccionar ubicación</h2>
    <mat-dialog-content>
      <div id="modalMap" style="height: 400px;"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" style="gap: 10px;">
      <button class="btn-delete" (click)="close()">Cancelar</button>
      <button
        style="width: 137px !important;"
        class="btn-update"
        (click)="saveCoordinates()"
      >
        Guardar
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ["./select-coordinates-modal.component.css"],
})
export class SelectCoordinatesModalComponent implements AfterViewInit {
  L: any;
  map: any;
  marker: any;
  selectedLat: number;
  selectedLng: number;

  constructor(
    public dialogRef: MatDialogRef<SelectCoordinatesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _alertService: AlertService
  ) {}

  ngAfterViewInit() {
    this.L = window["L"];
    this.map = this.L.map("modalMap").setView(
      [this.data.currentLat, this.data.currentLng],
      13
    );
    this.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(this.map);

    this.map.on("click", (e) => {
      const { lat, lng } = e.latlng;
      this.selectedLat = lat;
      this.selectedLng = lng;

      if (this.marker) {
        this.marker.setLatLng([lat, lng]);
      } else {
        this.marker = this.L.marker([lat, lng]).addTo(this.map);
      }
    });

    if (this.data?.currentLat && this.data?.currentLng) {
      this.selectedLat = this.data.currentLat;
      this.selectedLng = this.data.currentLng;
      this.marker = this.L.marker([this.selectedLat, this.selectedLng]).addTo(
        this.map
      );
      this.map.setView([this.selectedLat, this.selectedLng], 13);
    }
  }

  async saveCoordinates() {
    if (
      typeof this.selectedLat === "number" &&
      typeof this.selectedLng === "number"
    ) {
      const address = await this.getAddressFromCoordinates(
        this.selectedLat,
        this.selectedLng
      );

      this.dialogRef.close({
        lat: this.selectedLat,
        lng: this.selectedLng,
        address: address,
      });
    } else {
      this._alertService.openSnackBar(
        "Por favor, selecciona una ubicación en el mapa.",
        "warn"
      );
    }
  }

  close() {
    this.dialogRef.close();
  }

  getAddressFromCoordinates(lat: number, lng: number): Promise<string> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
    return fetch(url)
      .then((response) => response.json())
      .then((data) => data.display_name || "Dirección no disponible")
      .catch(() => "Error al obtener dirección");
  }
}
